


















































import '@/assets/scss/pages/page-auth.scss';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

import AButton from '@/components/common/AButton.vue';
import Avatar from '@/components/common/Avatar.vue';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { CheckIcon, Edit2Icon, FileTextIcon, InfoIcon, MoreVerticalIcon } from 'vue-feather-icons';
import { FlixcheckApi } from '@/services/integrations/FlixcheckApi';
import FormError from '@/components/common/forms/FormError.vue';

@Component({
  name: 'flixcheck-integrations-settings',
  components: {
    AdmiralCheckbox,
    Avatar,
    UserStatusBadge,
    MoreVerticalIcon,
    Edit2Icon,
    CheckIcon,
    AButton,
    InfoIcon,
    FileTextIcon,
    FormError,
  },
})
class FlixcheckIntegrationSettings extends mixins(BaseMixin, PermissionMixin) {
  userId = '';
  apiKey = '';
  isLoading = false;
  errors: Record<string, string[]> = {};

  isConnected = false;

  async mounted() {
    await this.checkIfConnected();
  }

  async connectToFlixcheck() {
    if (this.isConnected) {
      await FlixcheckApi.disconnect();
      await this.checkIfConnected();
      return;
    }
    this.isLoading = true;
    this.errors = {};
    try {
      const response = await FlixcheckApi.connectToFlixcheck(this.userId, this.apiKey);
      await this.checkIfConnected();
    } catch (error) {
      this.errors = {
        general: [
          'Etwas ist schiefgelaufen. Bitte überprüfe deine Eingaben und versuche es erneut.',
        ],
      };
    } finally {
      this.isLoading = false;
    }
  }
  async checkIfConnected() {
    this.isLoading = true;
    try {
      const response = await FlixcheckApi.isConnected();
      this.isConnected = response.data.isConnected;
      this.userId = response.data.userId || '';
      this.apiKey = response.data.apiKey || '';
    } catch (error) {
      this.isConnected = false;
    } finally {
      this.isLoading = false;
    }
  }
}

export default FlixcheckIntegrationSettings;
